import { Form, Input, Select } from 'antd';
import * as Component from 'components';
import { ACTION_TITLE, CAST_TYPE_OPTIONS, DEFAULT_CAST_TYPE } from 'constants/constant';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { peopleService } from '../services/peopleService';

const PeopleAdd: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  return (
    <Component.BasePageComponent>
      <div>
        <div className="people-details-page">
          <h1>People</h1>
          <Form form={form} layout="vertical" className="people-details-form">
            <Form.Item
              name="name"
              label="name"
              rules={[{ required: true, message: 'please enter name' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="name_en" label="name_en">
              <Input />
            </Form.Item>
            <Form.Item name="slug" label="slug">
              <Input />
            </Form.Item>
            <Form.Item
              name="thumbnail"
              label="Thumbnail"
              valuePropName="file"
              getValueFromEvent={e => e?.target?.files?.[0]}
            >
              <input
                type="file"
                accept="image/*"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    const imageUrl = URL.createObjectURL(file);
                    setPreviewUrl(imageUrl);
                  }
                  if (e.target.files?.[0]) {
                    form.setFieldsValue({ thumbnail: e.target.files[0] });
                  }
                }}
              />
              {previewUrl && (
                <img
                  src={previewUrl}
                  alt="thumbnail preview"
                  style={{ maxWidth: '200px', marginTop: '10px' }}
                />
              )}
            </Form.Item>
            <Form.Item name="type" label="Type" initialValue={DEFAULT_CAST_TYPE}>
              <Select options={CAST_TYPE_OPTIONS} placeholder="Select cast type" allowClear />
            </Form.Item>
            <Form.Item name="birthdate" label="birthdate">
              <Input type="date" />
            </Form.Item>
            <Form.Item name="nationality" label="nationality">
              <Input />
            </Form.Item>
          </Form>
        </div>
        <div className="people-detail-update-button">
          <Component.ColorButtonComponent
            text={ACTION_TITLE.ADD}
            onClick={() => {
              peopleService.createPeople(form, navigate);
            }}
          />
        </div>
      </div>
    </Component.BasePageComponent>
  );
};

export default observer(PeopleAdd);
